(module => {
  'use strict';
  MetadataCtrl.$inject = [
    '$scope',
    '$rootScope',
    '$sce',
    'FRONTEND3_URL',
    'FireTagService',
    'AdRequest'
  ];
  module.controller('MetadataCtrl', MetadataCtrl);
  function MetadataCtrl(
    $scope,
    $rootScope,
    $sce,
    FRONTEND3_URL,
    FireTagService,
    AdRequest
  ) {
    FireTagService.setPageView({
      title: 'Metadatos',
      path: `/${window.location.hash}`
    });
    $rootScope.adminTab.selected = 'metadata';

    $scope.iFrameUrl = function() {
      const token = AdRequest.getToken();
      const {postcenterVersion} = $rootScope;
      const url = `${FRONTEND3_URL}admin/metadata?auth=${token}&pc-ver=${postcenterVersion}`;
      return $sce.trustAsResourceUrl(url);
    };

    /*
    This listener triggers when the active element is going to be the iFrame
    and simulates a click in the top bar, closing any nav menu from it.
    Known issue: This listener does not work with the support chat bubble.
    This needs to be added for every iFrame with the new front.
    */
    addEventListener('blur', () => {
      if (
        document.activeElement === document.getElementById('metadataIframe')
      ) {
        const topBar = angular.element(
          document.getElementsByTagName('ad-top-bar')
        );
        topBar.trigger('click');
      }
    });
  }
})(angular.module('postCenterWebClientApp'));
